import React, { useState } from 'react';
import './Contact.css';
import emailjs from 'emailjs-com';
import ContactHeroSection from '../components/ContactHeroSection';
import ReCAPTCHA from 'react-google-recaptcha'; // Import reCAPTCHA


function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const [captchaVerified, setCaptchaVerified] = useState(false); // State to track reCAPTCHA verification
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCaptchaChange = (value) => {
    if (value) {
      setCaptchaVerified(true); // Set captchaVerified to true when reCAPTCHA is completed
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!captchaVerified) {
      setErrorMessage('Please verify that you are not a robot.');
      return;
    }

    // EmailJS configuration
    emailjs
      .send(
        'nh-contact-us', // Replace with your EmailJS service ID
        'nh-contact-us-template', // Replace with your EmailJS template ID
        {
          from_name: formData.name,
          from_email: formData.email,
          message: formData.message,
        },
        'DLxA8AgUdjpY3WaEO' // Replace with your EmailJS user ID
      )
      .then(
        (response) => {
          setSuccessMessage('Your message has been sent successfully!');
          setErrorMessage('');
          setFormData({ name: '', email: '', message: '' }); // Clear the form
        },
        (error) => {
          setErrorMessage('Failed to send your message. Please try again later.');
          setSuccessMessage('');
        }
      );
  };

  return (
    <div>
      <ContactHeroSection />
    
      <div className="contact-page">
        {/* <h1>Contact Us</h1>
        <p>We’d love to hear from you! Fill out the form below, and we’ll get back to you as soon as possible.</p> */}
        <form className="contact-form" onSubmit={handleSubmit}>
          <label>
            Name:
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Your Name"
              required
            />
          </label>
          <label>
            Email:
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Your Email"
              required
            />
          </label>
          <label>
            Message:
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Your Message"
              required
            ></textarea>
          </label>
        {/* reCAPTCHA */}
        <div className="recaptcha-container">
          <ReCAPTCHA
            sitekey="6LeeFB8rAAAAACBG_dpECLtQkQJSRETfBswVx8Fn" // Replace with your Google reCAPTCHA site key
            onChange={handleCaptchaChange}
          />
        </div>
          <button type="submit" className="submit-button">Send Message</button>
        </form>
        {successMessage && <p className="success-message">{successMessage}</p>}
        {errorMessage && <p className="error-message">{errorMessage}</p>}
      </div>
           {/* Contact Information */}
           <div className="contact-info">
        <h2>Our Office</h2>
        <p><strong>Location:</strong> Bedford, Nova Scotia</p>
        <p><strong>Contact Number:</strong> +782-234-2288</p>
      </div>

      {/* Google Map */}
      <div className="map-container">
        <iframe
          title="NorthHawks Office Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2830.123456789!2d-63.6781234!3d44.7351234!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4b59f123456789ab%3A0x123456789abcdef!2sBedford%2C%20Nova%20Scotia!5e0!3m2!1sen!2sca!4v1234567890123"
          width="100%"
          height="300"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div>
    </div>
  );
}

export default Contact;